import { useCallback } from 'react'
import { useSelector } from 'react-redux'
import { ApplicationState } from '@/state/root.models'

import { setSnackbarAction } from '@/state/ui/global/slices/index.slices'
import { SnackbarModel } from '@/state/ui/global/models'
import { useAppDispatch } from '@/state'

/**
 * @hook useSnackbar
 * @description Custom Hook to handle the snackbar action
 * @param {SnackbarModel} snackbarModel
 * @return Return an action with the properties and functions to close the snackbar (snackbar, closeSnackbar)
 */
const useSnackbar = (snackbarModel: Partial<SnackbarModel>) => {
  const dispatch = useAppDispatch()
  const { snackbar } = useSelector(({ globalUi }: ApplicationState) => globalUi)

  const { open, message, variant } = snackbarModel

  const closeHandler = useCallback(() => {
    dispatch(
      setSnackbarAction({
        ...snackbar,
        open: false,
      }),
    )
  }, [dispatch, snackbar])

  const actionHandler = useCallback(() => {
    if (open && message && variant) {
      dispatch(
        setSnackbarAction({
          open,
          message,
          variant,
        }),
      )
    }
  }, [dispatch, open, message, variant])

  if (open && message && variant) {
    return {
      snackbar,
      actionHandler,
      closeHandler,
    }
  }

  return {
    snackbar,
    closeHandler,
  }
}

export default useSnackbar
